import { render, staticRenderFns } from "./SocialLink.vue?vue&type=template&id=0aac46c5&"
import script from "./SocialLink.vue?vue&type=script&lang=js&"
export * from "./SocialLink.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./SocialLink.vue?vue&type=style&index=0&lang=sass&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  "bf245cf8"
  
)

export default component.exports